import React, { useEffect, useState } from 'react';
import { Download, Share, Plus, X } from 'lucide-react';
import { api } from '@/lib/api';

// Captures the beforeinstallprompt event so we can offer INSTALL.
let deferredPrompt = null;
if (typeof window !== 'undefined') {
  window.addEventListener('beforeinstallprompt', (e) => {
    e.preventDefault();
    deferredPrompt = e;
    window.dispatchEvent(new Event('ss-installable'));
  });
}

export const isStandalone = () =>
  window.matchMedia('(display-mode: standalone)').matches || window.navigator.standalone === true;

export const InstallButton = ({ className = '', label = 'Install KilalaRide', testid = 'install-button' }) => {
  const [installable, setInstallable] = useState(!!deferredPrompt);
  const [showHelp, setShowHelp] = useState(false);

  useEffect(() => {
    const h = () => setInstallable(true);
    window.addEventListener('ss-installable', h);
    return () => window.removeEventListener('ss-installable', h);
  }, []);

  if (isStandalone()) return null;

  const doInstall = async () => {
    api.track('install_started');
    if (deferredPrompt) {
      deferredPrompt.prompt();
      const { outcome } = await deferredPrompt.userChoice;
      if (outcome === 'accepted') api.track('install_completed');
      deferredPrompt = null;
      setInstallable(false);
    } else {
      setShowHelp(true);
    }
  };

  return (
    <>
      <button
        data-testid={testid}
        onClick={doInstall}
        className={`inline-flex items-center justify-center gap-2 rounded-full font-semibold min-h-[48px] px-5 transition-colors ${className}`}
        style={{ background: 'var(--primary)', color: 'var(--primary-foreground)' }}
      >
        <Download size={18} /> {label}
      </button>

      {showHelp && (
        <div className="fixed inset-0 z-50 flex items-end justify-center" style={{ background: 'rgba(0,0,0,0.5)' }} onClick={() => setShowHelp(false)}>
          <div className="w-full max-w-md rounded-t-3xl p-5" style={{ background: 'var(--surface)' }} onClick={(e) => e.stopPropagation()}>
            <div className="flex items-center justify-between mb-3">
              <h3 className="text-lg font-bold" style={{ color: 'var(--text)' }}>Add to Home Screen</h3>
              <button onClick={() => setShowHelp(false)} aria-label="Close"><X size={22} style={{ color: 'var(--text-muted)' }} /></button>
            </div>
            <div className="space-y-3 text-sm" style={{ color: 'var(--text)' }}>
              <p className="font-semibold">On iPhone (Safari):</p>
              <p className="flex items-center gap-2"><Share size={18} style={{ color: 'var(--primary)' }} /> Tap Share, then “Add to Home Screen”.</p>
              <p className="font-semibold mt-2">On Android (Chrome):</p>
              <p className="flex items-center gap-2"><Plus size={18} style={{ color: 'var(--primary)' }} /> Open the menu, then “Install app”.</p>
            </div>
          </div>
        </div>
      )}
    </>
  );
};
